const Services = () => {
  return (
    <div className=" koja-servises justify-content-center justify-content-md-start">
      <div
        className="black-strip2  d-none d-md-flex justify-content-center align-items-center"
        style={{ marginRight: "75px" }}
      >
        <h2 className="koja-servises-label text-nowrap">خدمات کجا</h2>
      </div>
      <div className="koja-servises-text-box">
        <div className="koja-servises-text">
          <h2 className="koja-servises-label text-nowrap d-md-none">
            خدمات کجا
          </h2>
          <p className="mb-0 servises-text" style={{ overflow: "hidden" }}>
            خدمات کجا در راستای خدمت به همشهریان عزیز برای دسترسی راحت و مطمئن به
            کارشناسان خبره ومتعهد در حوزه تعیین قیمت ملک،           سایت واپلیکیشن انلاین
            بومی (کجا نجف آباد)با تیمی مجرب وحرفه ای، تاسیس و راه اندازی شده است
            .سایت واپلیکیشن (کجا نجف آباد)یک پلتفرم نوبت دهی برای کارشناسان ملک
            در حوزه شهر نجف آباد می باشد. تنها با یک کلیک می توانید کارشناسی
            مورد نظرتان را از بین بهترین کارشناسان در سطح شهر انتخاب کنید(تنوع
            و تعدد کارشناسان در مناطق مختلف همراه با پشتیبانی سریع ومطمئن) کجا نجف
            آباد را به قطب نوبت دهی شهر مبدل خواهد کرد. به شما اطمینان می دهیم
            این بستر تبدیل به یک مرجع مطمئن برای سنجش صحت اطلاعات کارشناسی هنگام
            معاملات ملکی و سدی محکم و مطمئن در برابر کلاهبرداری های ممکن خواهد
            شد‌. امید است با حمایت شما مردم عزیز گامی بزرگ در راستای بهبود
            کارشناسی های املاک نجف آباد برداشته شود.
          </p>
          {/*
         <p className='mb-0' style={{overflow:"hidden"}}>
       در راستای کمک به همشهریان عزیز برای دسترسی راحت و مطمئن به کارشناسان خبره و مورد تایید 
       در حوزه تعیین قیت ملک در شان مردم عزیز شهر نجف آباد،
        سایت و اپلیکیشن آنلاین بومی "کجا نجف آباد" با تیمی مجرب و حرفه ای تاسیس و راه اندازی شده است.
        سایت و اپلیکیشن "کجا نجف آباد" یک پلتفرم نوبت دهی برای کارشناسان حوزه ملک در سطح شهرمان می‌باشد.
         تنها با یک کلیک می‌توانید کارشناس مورد نظرتان را از بین بهترین کارشناسان مورد تایید
        در شهر انتخاب کنید. تنوع و تعداد کارشناس‌ها در مناطق مختلف همراه با پشتیبانی سریع،
         "کجا نجف آباد" را به قطب نوبت‌ دهی شهر مبدل خواهد کرد. 
        همچنین این بستر تبدیل به یک مرجع مطمئن برای صحت‌سنجی 
        اطلاعات کارشناسی هنگام معاملات ملکی خواهد شد و سدی مطمئن در برابر کلاه‌برداری‌های ممکن می‌باشد.
        امید است با حمایت شما مردم عزیز گامی بزرگ در راستای اقتصاد و اشتغالزایی جوانان شهرمان برداریم.
       </p>
    */}
        </div>
      </div>
    </div>
  );
};

export default Services;
